import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from './env.service';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/interface/profile';

@Injectable({
  providedIn: 'root'
})

export class NewsLetterService {

  constructor(private http: HttpClient, private env: EnvService) { }
  newsLetter(queryParams): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.env.siteApiUrl + 'web/add-news-letter', 
      queryParams
    );
}
}
